module.exports = __webpack_public_path__ + "img/naira_white.020fc8fa.svg";